import { render, staticRenderFns } from "./RecordTypeCreateContainer.vue?vue&type=template&id=27cb5b20"
import script from "./RecordTypeCreateContainer.vue?vue&type=script&lang=js"
export * from "./RecordTypeCreateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports